"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _DynoTriggers = _interopRequireDefault(require("../DynoTriggers"));

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var AudienceTargetingTriggers =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AudienceTargetingTriggers, _Component);

  function AudienceTargetingTriggers() {
    (0, _classCallCheck2.default)(this, AudienceTargetingTriggers);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AudienceTargetingTriggers).apply(this, arguments));
  }

  (0, _createClass2.default)(AudienceTargetingTriggers, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor." + suffix;
    }
  }, {
    key: "handleUpdateTriggers",
    value: function handleUpdateTriggers(update) {
      var _this$props = this.props,
          addValidationError = _this$props.addValidationError,
          displayOnExitIntent = _this$props.displayOnExitIntent,
          displayOnScroll = _this$props.displayOnScroll,
          displayOnTimedDelay = _this$props.displayOnTimedDelay,
          removeValidationError = _this$props.removeValidationError,
          type = _this$props.type,
          updateDyno = _this$props.updateDyno;

      if (type !== _DynoTypes.default.POP_OVER) {
        update.displayOnExitIntent = false; // remove exit intent trigger from non-pop-over modals
      }

      updateDyno(update);
      var propTriggerValues = {
        displayOnExitIntent: displayOnExitIntent,
        displayOnTimedDelay: displayOnTimedDelay,
        displayOnScroll: displayOnScroll
      };
      var nowValues = Object.assign(propTriggerValues, update);
      var anyOn = nowValues.displayOnExitIntent || nowValues.displayOnTimedDelay || nowValues.displayOnScroll;

      if (!anyOn) {
        addValidationError('triggers', this.langKey('error.selectAtLeastOneTrigger'));
      } else {
        removeValidationError('triggers');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          type = _this$props2.type,
          displayOnExitIntent = _this$props2.displayOnExitIntent,
          displayOnScroll = _this$props2.displayOnScroll,
          displayOnTimedDelay = _this$props2.displayOnTimedDelay,
          validation = _this$props2.validation;
      if (type === _DynoTypes.default.EMBEDDED) return null;
      return _react.default.createElement(_UISection.default, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('targeting.triggers')
      })), _react.default.createElement(_DynoTriggers.default, {
        error: validation.triggers,
        validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.triggers),
        handleUpdateTriggers: function handleUpdateTriggers(update) {
          return _this.handleUpdateTriggers(update);
        },
        type: type,
        displayOnScroll: displayOnScroll,
        displayOnExitIntent: displayOnExitIntent,
        displayOnTimedDelay: displayOnTimedDelay
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        type: _react.PropTypes.string.isRequired,
        displayOnExitIntent: _react.PropTypes.bool.isRequired,
        displayOnScroll: _react.PropTypes.bool.isRequired,
        displayOnTimedDelay: _react.PropTypes.number.isRequired,
        validation: _react.PropTypes.object.isRequired,
        updateDyno: _react.PropTypes.func.isRequired,
        addValidationError: _react.default.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        validation: {}
      };
    }
  }]);
  return AudienceTargetingTriggers;
}(_react.Component);

var _default = AudienceTargetingTriggers;
exports.default = _default;
module.exports = exports.default;